import { render, staticRenderFns } from "./EmployeePermissions.vue?vue&type=template&id=4e4b3c90"
import script from "./EmployeePermissions.vue?vue&type=script&lang=js"
export * from "./EmployeePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports